import ICON_NEW from '../../../public/static/dummy.svg';
import Button, {IProps as IButtonProps} from '../../common/component/Button';

interface IProps extends IButtonProps {
  src: string;
  hasNew?: boolean;
  width: string;
  height: string;
}

export default function HeaderIcon({
  src,
  hasNew,
  width,
  height,
  alt,
  className,
  ...rest
}: IProps) {
  return (
    <Button {...rest} className={cn('cursor-pointer relative', className)}>
      <img src={src} width={width} height={height} alt={alt} />
      {hasNew && (
        <img
          src={ICON_NEW}
          width={4}
          height={4}
          className="absolute right-0 top-0 visible"
          alt="new"
        />
      )}
    </Button>
  );
}
